import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

//components
import FormLabel from '../Label';
import { FormInput } from 'components/common';
import ErrorField from '../ErrorField';
//styles
import { Suffix, SuffixIconWrapper } from './index.styled';
import { FormGroup } from 'components/styled/Form.styled';

const NumberField = ({
  name,
  label,
  error,
  isRequired,
  disabled,
  suffix,
  table,
  onChange,
  mb,
  onBlur,
}) => {
  // TODO should be updated we should send formiks setFieldValue as default onChange behavior
  return (
    <FormGroup mb={mb}>
      {label && <FormLabel isRequired={isRequired} label={label} name={name} error={error} />}
      <SuffixIconWrapper>
        {onChange ? (
          <FormInput
            disabled={disabled}
            name={name}
            error={error}
            type="number"
            onChange={onChange}
          />
        ) : (
          <FormInput disabled={disabled} name={name} error={error} type="number" onBlur={onBlur} />
        )}
        <Suffix error={error} table={table}>
          {suffix}
        </Suffix>
      </SuffixIconWrapper>
      {!table && <ErrorMessage name={name} component={ErrorField} />}
    </FormGroup>
  );
};

NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.bool,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  table: PropTypes.bool,
  suffix: PropTypes.string,
};

export default NumberField;
